import React from 'react';

// Component to render SVG images from external files with proper aspect ratio and sizing
const RackImage = ({ type, showDetail = false, vendor = 'AIC' }) => {
  // Map component types to SVG paths in the public directory based on vendor
  const getSvgPath = () => {
    // SMC uses perspective-corrected product photos (JPEG), one image per form factor
    if (vendor === 'SMC') {
      switch (type) {
        case 'dNode':
        case 'fNode': return '/images/1u-front.jpg';
        case 'sNode': return '/images/2u-front.jpg';
        case 'jbod':  return '/images/jbod-front.jpg';   // covers 4U60 and 4U90
        default:      return null;
      }
    }

    // Dell-specific images
    if (vendor === 'DELL') {
      switch (type) {
        case 'dNode':
          return '/images/dell-dnode.svg';
        case 'fNode':
          return '/images/dell-fnode.svg';
        case 'sNode':
          return '/images/dell-snode.svg';
        case 'jbod':
          return '/images/dell-4Ujbod.svg';
        case 'jbod-8u': // New component type for Dell 8U server
          return '/images/dell-8Ujbod.svg';
        case 'rack':
          return null;
        default:
          return null;
      }
    }
    
    // Default AIC images (existing logic)
    switch (type) {
      case 'dNode':
        return '/images/dnode.svg';
      case 'fNode':
        return '/images/fnode.svg';
      case 'sNode':
        return '/images/snode.svg';
      case 'jbod':
        return '/images/jbod.svg';
      case 'rack':
        return null;
      default:
        return null;
    }
  };
  
  // For rack or empty types, render the default SVG directly
  const renderDefaultSvg = () => {
    if (type === 'rack') {
      // Use exact 21:73.5 ratio for a 42U rack (21" width × 73.5" height)
      // This maintains the proper proportions of a standard 42U rack
      return (
        <svg viewBox="0 0 21 73.5" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
          <rect width="21" height="73.5" fill="#222222" />
          <g>
            {/* Main rack frame - exact 21" width */}
            <rect x="0" y="0" width="21" height="73.5" fill="#222222" />
            
            {/* Vertical rails - 1" on each side */}
            <rect x="0" y="0" width="1" height="73.5" fill="#333333" />
            <rect x="20" y="0" width="1" height="73.5" fill="#333333" />
            
            {/* Mounting strips */}
            <rect x="1" y="0" width="0.5" height="73.5" fill="#444444" />
            <rect x="19.5" y="0" width="0.5" height="73.5" fill="#444444" />
            
            {/* Interior area - exactly 19" wide for equipment */}
            <rect x="1.5" y="0" width="18" height="73.5" fill="#222222" />
          </g>
        </svg>
      );
    }
    
    // Default empty SVG
    return (
      <svg viewBox="0 0 19 1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
        <rect width="19" height="1" fill="#222222" />
      </svg>
    );
  };
  
  const svgPath = getSvgPath();
  
  // If we have an external SVG path, render it as an image with proper aspect ratio
  if (svgPath) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <img 
          src={svgPath}
          alt={`${type} component`}
          className="w-full h-full"
          style={{ 
            objectFit: 'fill', // Fill the entire space
            objectPosition: 'center'
          }}
        />
      </div>
    );
  }
  
  // Otherwise render the default SVG
  return (
    <div className="w-full h-full">
      {renderDefaultSvg()}
    </div>
  );
};

export default RackImage;